<template>
	<div class="pre-check-in">
		<!-- 预入住登记 -->
		<section class="register">
			<div class="one">
				<section class="top">

					<h3>客房详情</h3>
					<div id="three"></div>
					<el-button @click="toCustomerRoom" class="detail">查看详情</el-button>

				</section>
			</div>
			<div class="zero">
				<h3>人才详情</h3>
				<div id="five"></div>
				<!-- <img src="../../assets/icon/detail.png" alt="" class="detail" @click="toTalentDetail"> -->
				<el-button @click="toTalentDetail" class="detail">查看详情</el-button>
			</div>
			<div class="two">
				<el-tabs v-model="activeNotice" @tab-click="handleNotice">
					<el-tab-pane label="公告" name="first"></el-tab-pane>
					<el-tab-pane label="通知" name="second"></el-tab-pane>
					<div>
						<p v-for="(item,index) in noticeAndMessageNum" class="message"><span
								class="circle"></span>{{item.title}}
							<span
								style="font-size: small;position: absolute;right: 5px;">{{item.days==0?'今天发送':item.days+'天前发送'}}</span>
						</p>
					</div>
				</el-tabs>
				<p @click='$router.push("/index/console/announceAndNotice")' class="more">更多</p>
			</div>

		</section>
		<section class="bottom"
			style="display: flex;justify-content: space-between;border: 1px solid #999;width: 95%;margin: 20px auto;">
			<div style="width: 60%;">
				<h3 style="padding: 0px 40px 20px 40px;">常用功能</h3>
				<div style="display: flex;justify-content: space-between;padding: 0 40px;">

					<div @click="goDe(s.name)" v-for="s in cdList" style="width: 18%;border: 1px solid #999;">
						<div style="width: 20px;height: 20px;border-radius: 20px;background-color: red;color: white;text-align: center;">{{s.count}}</div>
						<div style="display: flex;padding: 10px;">
							<div>
								<img style="width: 50px;height: 50px;" :src="s.icon">
							</div>
							<div style="display: flex;align-items: center;">{{s.name}}</div>
						</div>
						
					</div>
					
				</div>
			</div>
			<div style="width: 30%;">
				<h3>访客查看</h3>
				<div v-for="s in fkList" style="display: flex;justify-content: space-between;margin: 10px 0;color: #666;">
					<div>{{s.roomNumber}}</div>
					<div>{{s.intervieweeName}}</div>
					<div>提交访客申请</div>
					<div>{{s.createTime}}</div>
				</div>
				<div style="font-weight: 800;text-align: center;" @click="goFk">查看更多</div>
			</div>
			<!-- <div class="four" @mousemove="buildShow=true" @mouseout="buildShow=false">
				<h3>费用信息</h3>
				<el-button class="detail">查看详情</el-button>
				<p class="build" v-show="buildShow">正在建设中</p>
				<div id="four">
				</div>
			</div>
 -->
		</section>

		<!-- 增加预入住登记 -->
		<el-dialog title="预入住登记" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
			 :modal-append-to-body="false" :before-close="handleClose">
			<div style="margin: 20px 10px;">
				<el-radio v-model="subscribePlanFlag" :label="2">暂无入住</el-radio>
				<el-radio v-model="subscribePlanFlag" :label="1">预入住登记</el-radio>
			</div>
			<el-form :model="checkInFormData" label-width="100px" :rules="rules" ref="formData">
				<template v-if="subscribePlanFlag==1">
					<el-form-item label="预约房间数" prop="roomNum">
						<el-input v-model.number="checkInFormData.roomNum" type="number" placeholder="请输入数量"
							style="width: 80%;" min="0"></el-input>
					</el-form-item>
					<el-form-item label="预入住人数" prop="personNum">
						<el-input v-model.number="checkInFormData.personNum" type="number" placeholder="请输入数量"
							style="width: 80%;" min="0" @input="personNumInput"></el-input>
					</el-form-item>
				</template>
				<template v-else>
					<el-form-item label="入住计划" prop="subscribePlanYear">
						<el-select v-model="checkInFormData.subscribePlanYear" clearable="">
							<el-option value="半年以内" label="半年以内"></el-option>
							<el-option value="半年以上一年以内" label="半年以上一年以内"></el-option>
							<el-option value="一年以上" label="一年以上"></el-option>
						</el-select>
					</el-form-item>
				</template>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelClick">取 消</el-button>
				<el-button style="background-color:#B5AC8B;color: white;" @click="confirmClick">确 定</el-button>
			</span>
		</el-dialog>



		<PersonalInfor :personInforVisible="personInforVisible" @changeVisible="changeVisible"></PersonalInfor>


	</div>
</template>

<script>
	import vueQr from 'vue-qr'
	import {
		phoneRules,
		checkIdentitytionId
	} from '../apartment/verify.js'
	import publicExport from '../../assets/js/publicExport.js'
	import downloadFile from '../../assets/js/downloadFile.js'
	import PersonalInfor from './component/PersonInfor.vue';


	export default {
		data() {
			let pattern = /^[1-9][0-9]*$/;
			let validateRoomNum = (rule, value, callback) => {
				if (value > this.allRoomNum) {
					callback(new Error("预约房间数不可以大于可用房总数"));
				} else if (!pattern.test(value)) {
					callback(new Error("预约房间数必须为整数"));
				} else {
					callback();
				}
			}

			let validatePersonNum = (rule, value, callback) => {
				// if (value > this.formData.roomNum * 2 + 5) {
				// 	callback(new Error("预约入住人数建议不要过多"));
				// } else 
				if (!value) {
					console.log("---------");
					this.$message.close();
					callback(new Error("请输入房间数"));
				} else if (!pattern.test(value)) {
					callback(new Error("预约入住人数必须为整数"));
				} else {
					callback();
				}
			}
			return {
				cdList: [{
						name: '报修管理',
						icon: require('../../assets/imgs/bx.png'),
						count:null
					},
					{
						name: '家政服务',
						icon: require('../../assets/imgs/jz.png'),
						count:null
					},  {
						name: '投诉建议',
						icon: require('../../assets/imgs/ts.png'),
						count:null
					}, {
						name: '入住申请',
						icon: require('../../assets/imgs/xj.png'),
						count:null
					},
					// , {
					// 	name: '巡检上报',
					// 	icon: require('../../assets/imgs/xj.png'),
					// 	count:null
					// }
					{
						name: '商务会客',
						icon: require('../../assets/imgs/sw.png'),
						count:null
					},
				],
				dialogVisible: false,
				isShowPreCheckIn: null, //是否预入住登记
				allRoomNum: null,
				formData: {
					// subscribePlanFlag: 1,
					personNum: null,
					roomNum: null,
					subscribePlanYear: "半年以内",
				},
				flag: null,
				subscribePlanFlag: 1,
				formData2: {
					personNum: null,
					roomNum: null,
					subscribePlanYear: "半年以内",
				},
				checkInFormData: {},
				imageUrl: "",
				// propertyFeeVisible: false, //物业费显隐
				//fireSafetyVisible: false, //消防安全显隐
				tenementChecked: false, //单位checkbox
				fireChecked: false, //消防checkbox

				personInforVisible: false, //个人信息显影

				activeNotice: 'first', //选中的信息

				rules: {
					roomNum: [{
						required: true,
						message: '预约房间数不能为空',
						trigger: ["blur", "change"]
					}, {
						validator: validateRoomNum,
						trigger: ["blur", "change"]
					}],
					personNum: [{
						required: true,
						message: '预入住人数不能为空',
						trigger: ["blur", "change"]
					}, , {
						validator: validatePersonNum,
						trigger: ["blur", "change"]
					}],
				},
				countList:[],
				sum: 0, //所有客房数量
				free: 0, //空闲中数量
				checkedIn: 0, //已入住数量
				toBeCheckIn: 0, //待入住数量
				maintain: 0, //维护中数量
				noticeAndMessageNum: [],
				fkList:[],
				buildShow: false,
				downloadData: {
					url: 'https://www.jsitc.net.cn/mobileForm?ownerId=' + sessionStorage.getItem("createId"), //需要转化成二维码的网址
					//url: 'https://rcweb.yjhj.city/mobileForm?ownerId=' + sessionStorage.getItem("createId"), //需要转化成二维码的网址
					icon: require("../../assets/icon/logo.png") //二维码中间的图片,可以不设置
				},

			}
		},
		components: {
			PersonalInfor,
			vueQr,
		},

		mounted() {
			this.getAll();
			this.isJudgePopup();
			this.getPieEcharts();
			// this.getLineEcharts();
			this.getBarEchars();
			this.getNoticeAndMessage();
			this.getSum()
			this.getXj()
		},
		methods: {
			goFk(){
				this.$router.push("/index/visitor")
			},
			
			getXj(){
				this.$http.post("/api/bdVisitApply/queryWebVisitApply",{
					
				}).then(res=>{
					console.log(res)
					res.data.data.items.forEach(val=>{
						val.createTime=val.createTime.split("T")[0]
					})
					this.fkList=res.data.data.items
				})
			},
			goDe(val){
				if(val=='报修管理'){
					this.$router.push("/index/apartment/repair")
				}
				if(val=='家政服务'){
					this.$router.push("/index/apartment/jiazhen")
				}
				if(val=='商务会客'){
					this.$router.push("/index/apartment/swhk")
				}
				if(val=='投诉建议'){
					this.$router.push("/index/apartment/advice")
				}
				if(val=='入住申请'){
					this.$router.push("/index/apartment/occupancyApplication")
				}
				if(val=='巡检上报'){
					this.$router.push("/index/apartment/jiazhen")
				}
			},
			getSum() {
				this.$http.get("/api/screen/getCount").then(res => {
					console.log(res)
					this.cdList[0].count=res.data.data.bdRepairApplyCount
					this.cdList[1].count=res.data.data.bdServiceApplyCount
					this.cdList[2].count=res.data.data.bdComplaintCount
					this.cdList[3].count=res.data.data.bdCheckInApplyCount
					this.cdList[4].count=res.data.data.bdMeetingApplyCount
				
				})
			},
			getAll() {
				// 
				this.$http.get("/api/ownerManage/getOwnerSubscribe").then(res => {
					console.log(res.data)
					if (res.data.code == -1) {
						this.isShowPreCheckIn = true;
						return;
					}
					this.isShowPreCheckIn = false;
					this.formData = res.data.data;
				})

				// 所有房间数
				this.$http.get("/api/ownerManage/getAllRoomNum").then(res => {
					this.allRoomNum = res.data.data;
				})
			},

			// 
			getNoticeAndMessage() {
				let url;
				if (this.activeNotice == "second") {
					url = "/api/message/queryReceiverMessage";
				} else {
					url = "/api/notice/app/queryReceiverNotice";
				}

				this.$http.post(url, {
					currentPage: 1,
					pageSize: 3,
				}).then(res => {
					if (res.data.code == 0) {
						this.noticeAndMessageNum = res.data.data.items;
					}
				})
			},


			// 是否弹出物业消费框
			isJudgePopup() {
				this.$http.get("/api/ownerManage/judgePopup").then(res => {
					this.propertyFeeVisible = res.data.data;
					// this.propertyFeeVisible = true;
				})
			},

			// 饼图
			getPieEcharts() {
				let myChart = this.echarts.init(document.getElementById('three'));

				this.$http.get("/api/roomManage/countRoom").then(res => {
					console.log("客房数", res);
					this.sum = res.data.data.sum;
					this.free = res.data.data.free;
					this.maintain = res.data.data.maintain;
					this.toBeCheckIn = res.data.data.toBeCheckIn;
					this.checkedIn = res.data.data.checkedIn;

					let data = [{
							value: this.free,
							name: "空闲中"
						},
						{
							value: this.maintain,
							name: "维护中",
						},
						{
							value: this.toBeCheckIn,
							name: "待入住"
						},
						{
							value: this.checkedIn,
							name: "已入住"
						}
					];
					let option = {

						tooltip: {
							trigger: 'item',
							formatter: "{a} <br/>{b} : {c}"
						},
						legend: {
							x: 'center',
							y: 'bottom',
							data: ['待入住', '空闲中', '已入住', '维护中']
						},
						series: [{
							name: '客房信息',
							type: 'pie',
							radius: ['40%', '70%'],
							data: data,
							emphasis: {
								label: {
									show: true,
									fontSize: '20',
									fontWeight: 'bold'
								}
							},

							itemStyle: {
								normal: {
									label: {
										show: true,
										formatter: '{b} : {c} '
									},
								},
							}
						}]
					}
					myChart.setOption(option)

				})
			},

			// 折线图
			getLineEcharts() {
				let myChart = this.echarts.init(document.getElementById('four'));
				console.log(myChart);
				this.$http.get("/api/checkInApply/countTalentByLevel").then(res => {

				})
				let option;
				option = {
					title: {
						text: '费用信息',
						x: 'center',
					},
					xAxis: {
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: [150, 230, 224, 218, 135, 147, 260],
						type: 'line'
					}]
				};
				myChart.setOption(option);
			},

			// 柱形图
			getBarEchars() {
				let myChart = this.echarts.init(document.getElementById('five'));
				console.log(myChart);
				this.$http.get("/api/checkInApply/countTalentByLevel").then(res => {
					let data = [{
							value: res.data.data.undergraduate,
							name: "本科"
						},
						{
							value: res.data.data.master,
							name: "硕士",
						},
						{
							value: res.data.data.doctor,
							name: "博士"
						},
						{
							value: res.data.data.expert,
							name: "专家"
						},
						{
							value: res.data.data.returnees,
							name: "海归"
						}
					];
					let option = {
						tooltip: {
							trigger: 'item',
							formatter: "{a} <br/>{b} : {c}"
						},
						legend: {
							x: 'center',
							y: 'bottom',
							data: ['本科', '硕士', '博士', '专家', '海归']
						},
						series: [{
							name: '人才信息',
							type: 'pie',
							radius: '50%',
							data: data,
							avoidLabelOverlap: true, //图饼标签false重复
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							},
							itemStyle: {
								normal: {
									label: {
										show: true,
										formatter: '{b} : {c} '
									},
									labelLine: {
										show: true
									}
								},
							}
						}]
					}
					myChart.setOption(option);
				})
			},


			// 预入住登记
			preCheckInClick() {
				this.flag = true;
				this.formData = {
					...this.formData2
				}
				this.perfectInfor();

			},
			// 判断是否已完善个人信息
			perfectInfor() {
				this.$http.get("/api/ownerManage/perfectInformation").then(res => {
					console.log(res);
					if (res.data.data) {
						this.dialogVisible = true;
					} else {
						this.personInforVisible = true;

						// this.$confirm('请点击右上方完善个人信息', '提示', {
						// 	confirmButtonText: '确定',
						// 	cancelButtonText: '取消',
						// 	type: 'warning'
						// })
					}


				})
			},

			// 子组件向父组件传值personInforVisible
			changeVisible(e) {
				this.personInforVisible = e.personInforVisible;
			},

			// 修改
			modifyClick() {
				this.flag = false;
				this.dialogVisible = true;
				this.checkInFormData = {
					...this.formData
				};
			},
			// 取消
			cancelClick() {
				if (this.isShowPreCheckIn) {
					this.checkInFormData = {
						...this.formData
					};
				}
				console.log(this.checkInFormData);
				console.log(this.$refs.formData);
				this.$refs.formData.clearValidate();
				this.dialogVisible = false;
			},
			//
			handleClose() {
				if (this.isShowPreCheckIn) {
					this.checkInFormData = {
						...this.formData
					};
				}
				this.$refs.formData.clearValidate();
				this.dialogVisible = false;
			},

			// 确定
			confirmClick() {
				console.log(this.checkInFormData);
				this.checkInFormData.subscribePlanFlag = this.subscribePlanFlag;
				this.$refs.formData.validate((valid) => {
					if (!valid) {

					} else {
						if (this.flag) {
							this.$http.post("/api/ownerManage/addOwnerSubscribe", {
								...this.checkInFormData
							}).then(res => {
								this.getAll();
								this.dialogVisible = false;
							})
						} else {
							this.$http.post("/api/ownerManage/modifyOwnerSubscribe", {
								...this.checkInFormData
							}).then(res => {
								this.getAll()
								this.dialogVisible = false;
							})
						}
					}
				})

			},

			// 物业费通知
			confirmTenement(type) {
				this.$http.post("/api/ownerManage/approveFireControl", {
					type: type,
					key: "是",
				}).then(res => {
					if (type == 2) {
						this.fireSafetyVisible = true;
						this.propertyFeeVisible = false;
					} else {
						this.fireSafetyVisible = false;
					}

				})
			},

			// 
			personNumInput() {
				if (this.checkInFormData.roomNum * 2 < this.checkInFormData.personNum) {
					this.$message({
						message: "预约入住人数建议不要过多",
						showClose: true,
					});
				}
			},


			// 子组件向父组件传值
			changeVisible(e) {
				this.personInforVisible = e.personInforVisible;
				if (e.hasOwnProperty("isAlert")) {
					this.dialogVisible = true;
				}
			},

			// 下载文件
			downloadFile(val) {
				var file = {};
				if (val == 1) {
					file.name = "物业费说明.doc";
					file.url = "/home/boding/message/发业主收物业费说明.doc";
				} else {
					file.name = "消防安全责任书.doc";
					file.url = "/home/boding/message/消防安全责任书.doc";
				}
				downloadFile(file);
			},

			// 公告、通知的事件
			handleNotice() {
				this.getNoticeAndMessage();
			},

			// 去客房详情
			toCustomerRoom() {
				this.$router.push("/index/apartment/customerInformation/customerRoom")
			},
			// 去人才详情
			toTalentDetail() {
				this.$router.push("/index/apartment/personnelInformation");
			},
			// 马上入住
			toApplyCheckIn() {
				this.$router.push("/index/apartment/personnelInformation");
			}
		},
	}
</script>

<style scoped="scoped">
	.pre-check-in {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.bg {
		width: 100%;
		height: 250px;
		position: absolute;
		left: 0;
		bottom: 10px;
		padding-right: 15px;
	}

	img {
		width: 100%;
		height: 100%;
	}

	.description {
		/* text-align: center; */
	}

	.description>p {
		color: #747474;
		margin: 15px 0;
	}

	.isShowPreCheckIn {
		/* text-align: center; */
		padding: 40px 0;
	}

	.isShowPreCheckIn p {
		margin: 15px 0;
	}

	.rightHousesNumber {
		color: #00a790;
		font-weight: bolder;
		font-size: 24px;
		margin: 0 10px;
	}

	.rightHousesNumber p {
		margin: 15px 0;
	}

	.preBtn {
		width: 300px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		background-color: #B5AC8B;
		color: white;
		display: inline-block;
		border-radius: 5px;
		font-weight: bold;
	}

	.preCheckIn {}

	.preCheckIn ul {
		padding-top: 60px;
		display: flex;
		justify-content: space-evenly;
	}

	.preCheckIn ul li {
		text-align: center;
	}

	.preCheckIn ul li p {
		margin: 10px 0;
	}

	.preCheckIn ul li p:nth-of-type(1) {
		font-weight: bolder;
		color: #454851;
	}


	.preCheckIn ul li img {
		width: 70px;
		height: 70px;
	}

	.number {
		font-weight: bolder;
		color: #00BFAF;
		font-size: 26px;
	}

	.modifyImg {
		position: absolute;
		top: 15px;
		right: 30px;
		display: block;
		width: 40px;
		height: 40px;
	}



	.zero div:nth-of-type(1) {
		display: flex;
		padding-top: 10px;
	}

	.zero div div:nth-of-type(1) {
		padding-top: 20px;
	}

	.zero div div:nth-of-type(2) {
		margin-top: 100px;
	}

	.zero img {
		width: 200px;
		height: 200px;
	}


	.tenement>p,
	.fireSafety>p {
		margin: 15px 0;
		letter-spacing: 2px;
		line-height: 30px;
		font-size: 16px;
	}

	.fireSafety>p {
		text-indent: 2em;
	}

	.download {
		font-size: small;
		color: #666666;
		cursor: pointer;
	}

	.register {
		display: flex;
		justify-content: space-evenly;
		margin-top: 30px;
	}



	.top {
		height: 300px;
	}

	.bottom {
		display: flex;
		justify-content: space-evenly;
		padding: 20px 0;
	}

	.one,
	.two,
	.zero,
	.three,
	.four,
	.five {
		width: 30%;
		position: relative;
		border: 1px solid #CCCCCC;
		padding: 20px;
	}

	#three,
	#four,
	#five {
		height: 300px;
	}



	.build {
		position: absolute;
		top: 0;
		display: block;
		width: 102%;
		height: 382px;
		line-height: 350px;
		text-align: center;
		background-color: #4a4a4a;
		color: white;
		z-index: 1000;
		opacity: 0.8;
		font-size: larger;
	}

	.detail {
		/* width: 45px;
		height: 45px; */
		position: absolute;
		top: 15px;
		right: 30px;
	}

	.more {
		position: absolute;
		bottom: 10px;
		right: 10px;
		cursor: pointer;
	}

	.circle {
		width: 6px;
		height: 6px;
		line-height: 6px;
		border-radius: 6px;
		display: inline-block;
		background-color: #CCCCCC;
		margin: 0 15px;
		position: relative;
		top: -1px;
	}

	.message {
		font-size: 15px;
		height: 25px;
		line-height: 25px;
		color: black;
		position: relative;
	}

	.message:hover {
		cursor: pointer;
		color: lightslategray;
	}
</style>
